import { groupBy } from "lodash-es";
import {
  acceptHotItemStore,
  defineItemStore
} from "@editor/items/itemStore.store";

import { useConditionStore } from "@editor/items/condition/conditions.store";

import type { IncidentTriggerItem } from "./IncidentTriggerItem";

/**
 * Triggers are groups of conditions that activate an incident
 * All conditions must apply before triggering
 * The trigger has a chance to trigger.
 * The trigger can be limited (only occur a certain number of times during a simulation)
 */

const itemStructure: IncidentTriggerItem = {
  type: "incidentTrigger",
  id: -1,
  uid: "incidentTrigger_-1",
  createdAt: -1,

  incidentId: -1,
  maxOccurrences: null,
  chance: 100,

  title: "",
  description: ""
};

export const useIncidentTriggerStore = defineItemStore(
  "model/incidentTriggers",
  itemStructure,
  {
    getters: {
      byIncident(state) {
        return groupBy(state.items, "incidentId");
      }
    },

    events: {
      async afterDelete(incidentTrigger) {
        // delete all conditions that are connected with this incidentTrigger
        const conditionStore = useConditionStore();
        const conditions = conditionStore.getBySource(incidentTrigger);
        if (conditions.length > 0) {
          await conditionStore.deleteMany(conditions);
        }

        return incidentTrigger;
      }
    },

    actions: {
      async duplicate(id: number, changes: Partial<IncidentTriggerItem> = {}) {
        const trigger = this.items[id];
        const duplicated = await this.super.duplicate(id, changes);

        // duplicate conditions
        const conditionStore = useConditionStore();
        const conditions = conditionStore.getBySource(trigger);
        for (const condition of conditions) {
          await conditionStore.duplicate(condition.id, {
            srcId: duplicated.id,
            srcType: "incidentTrigger"
          });
        }

        return duplicated;
      }
    }
  }
);

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHotItemStore(useIncidentTriggerStore, import.meta.hot)
  );
}
